export const BRAND = {
  name: "Central Alberta Junk Removal",
  phone: "403-550-7323",
  phoneHref: "tel:+14035507323",
  email: "centralalbertajunk@gmail.com",
  area: "Central Alberta area",
  // To use the exact "write a review" link, replace with:
  // https://search.google.com/local/writereview?placeid=YOUR_PLACE_ID
  googleReviewUrl: "https://www.google.com/maps/search/?api=1&query=Central+Alberta+Junk+Removal+Ponoka",
  towns: ["Ponoka", "Red Deer", "Lacombe", "Rimbey", "Wetaskiwin", "Sylvan Lake", "Blackfalds", "Bashaw"],
};

export const IMAGES = {
  logo: "/logo.png",
  heroTexture: "https://images.pexels.com/photos/18599094/pexels-photo-18599094.jpeg",
  truck: "https://images.unsplash.com/photo-1781425009053-2baffa997d8c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  garage: "https://images.unsplash.com/photo-1647299852821-40401c0b0976?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  furniture: "https://images.pexels.com/photos/327712/pexels-photo-327712.jpeg?auto=compress&cs=tinysrgb&w=1200",
  appliances: "https://images.unsplash.com/photo-1588854337115-1c67d9247e4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
